import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [{ path: 'team', lazy: async () => ({ Component: (await import('./TeamPage')).TeamPage }) }];
